import FooterDesktop from "@Components/FooterV2/FooterDesktop";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./V2Footer.module.scss";

/**
 * The site footer as the v2 pages use it: unchanged, with a rule along its top edge.
 *
 * ⚠️  A WRAPPER, NOT AN EDIT TO THE FOOTER. `FooterV2/FooterDesktop` is rendered by 47
 * other pages, and it sets no top border of its own — every one of those pages either
 * ends in a band that provides its own edge or is meant to run straight into it. Adding
 * the rule inside the footer would have changed all 47.
 *
 * The v2 pages end on white, so the footer arrives with nothing separating it from the
 * section above and the two read as one undifferentiated block. This gives them the
 * edge without touching anyone else's page.
 *
 * One component rather than the same wrapper div copied into nine pages, so the rule
 * has a single definition — and swapping the import back is how a page opts out.
 */
const V2Footer = () => (
  <div className={styles.wrap}>
    <FooterDesktop />
  </div>
);

export default wrapperHOC(V2Footer, {
  componentName: "V2Footer",
  showForChina: true,
});
